import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Banner from "../component/Banner";
import FilterBox from "../component/FilterBox";
import MostCommunitiesRecognizedIcon from "../component/MostCommunitiesRecognized";
import HomeResources from "../component/HomeResources";
import HomeThreePoint from "../component/HomeThreePoint";
import HomeGreatFullLife from "../component/HomeGreatFullLife";
import HomeSeniorLivingOptions from "../component/HomeSeniorLivingOptions";
import HomeBlog from "../component/HomeBlog";
import HomeStories from "../component/HomeStories";
import HomeCareers from "../component/HomeCareers";
import Footer from "../component/Footer";
import "../scss/home.scss";

import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

function Home() {
  
  const [homeData, setHomeData] = useState(null);
  const { pageResponse } = useSelector((state) => state.visitor);

  useEffect(() => {
    if (pageResponse) {
      let home = pageResponse.find((r) => r.code === "home");
      setHomeData(home.home_section);
    }
  }, [pageResponse]);

  return (
    <>
      <Helmet>
        <title>Welcome | Helpotani</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
      </Helmet>
      <main className="main home-page">
        <Header />
        <Banner />
        <FilterBox />
        <MostCommunitiesRecognizedIcon
          data={homeData?.section_1 ? homeData.section_1 : null}
        />
        <HomeResources data={homeData?.section_2 ? homeData.section_2 : null} />
        <HomeThreePoint
          data={homeData?.section_3 ? homeData.section_3 : null}
        />
        <HomeGreatFullLife
          data={homeData?.section_4 ? homeData.section_4 : null}
        />
        <HomeSeniorLivingOptions
          data={homeData?.section_5 ? homeData.section_5 : null}
        />

        <HomeBlog />
        <HomeStories />
        <HomeCareers data={homeData?.section_6 ? homeData.section_6 : null} />
      </main>
      <Footer />
    </>
  );
}
export default Home;
